import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Drawer, Button, Menu, Space } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

export default function Header({
  onOpenRules,
  onOpenLibrary,
  onOpenReference,
  onNewEditor,
  user,
  onLogout,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleNavClick = (callback) => {
    callback();
    setMenuOpen(false);
  };

  const menuItems = [];

  if (location.pathname !== '/svgs') {
    menuItems.push({
      key: 'library',
      label: 'SVG library',
      onClick: () => handleNavClick(() => navigate('/svgs')),
    });
  }

  if (location.pathname !== '/editor' && !location.pathname.startsWith('/editor/')) {
    menuItems.push({
      key: 'new-editor',
      label: 'New sign',
      className: 'ant-menu-item-primary',
      onClick: () => handleNavClick(() => navigate('/editor')),
    });
  }

  if (onOpenRules) {
    menuItems.push({
      key: 'rules',
      label: 'Rules Editor',
      onClick: () => handleNavClick(onOpenRules),
    });
  }

  if (onOpenReference) {
    menuItems.push({
      key: 'reference',
      label: 'IRC Reference',
      onClick: () => handleNavClick(onOpenReference),
    });
  }

  if (user) {
    menuItems.push({
      key: 'logout',
      label: 'Logout',
      danger: true,
      onClick: () => handleNavClick(onLogout),
    });
  }

  const onRules = typeof onOpenRules === 'function' ? onOpenRules : null;
  const onReference = typeof onOpenReference === 'function' ? onOpenReference : null;

  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <div className="header-logo">IRC</div>
          <div className="header-title">
            <h1>Road Sign Generator</h1>
            <span>IRC:67-2022 Compliant &bull; Section 16 &amp; 17</span>
          </div>
        </div>
        <div className="header-right">
          <div className="header-nav-desktop">
            {user && <span className="header-username">{user.username}</span>}
            <Space size="small">
              {location.pathname !== '/svgs' && (
                <Button size="small" onClick={() => navigate('/svgs')}>
                  SVG library
                </Button>
              )}
              {location.pathname !== '/editor' && !location.pathname.startsWith('/editor/') && (
                <Button size="small" type="primary" onClick={() => navigate('/editor')}>
                  New sign
                </Button>
              )}
              {onRules && (
                <Button size="small" onClick={onRules}>
                  Rules Editor
                </Button>
              )}
              {onReference && (
                <Button size="small" onClick={onReference}>
                  IRC Reference
                </Button>
              )}
              {user && (
                <Button size="small" danger onClick={onLogout}>
                  Logout
                </Button>
              )}
            </Space>
          </div>

          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setMenuOpen(true)}
            className="header-menu-toggle"
            aria-label="Toggle menu"
          />
        </div>
      </header>

      <Drawer
        title={user ? <div className="mobile-menu-user"><span>{user.username}</span></div> : null}
        placement="right"
        onClose={() => setMenuOpen(false)}
        open={menuOpen}
        className="header-drawer"
        styles={{
          body: { padding: 0 },
          header: {
            background: 'var(--bg-secondary)',
            borderBottom: '1px solid var(--border-color)',
            padding: '12px 20px',
          },
        }}
        style={{ zIndex: 1000 }}
      >
        <Menu
          mode="vertical"
          items={menuItems.map((item) => ({
            key: item.key,
            label: item.label,
            danger: item.danger,
            onClick: item.onClick,
            className: item.className || '',
          }))}
          className="header-mobile-menu"
        />
      </Drawer>
    </>
  );
}
